export default {"src":"/pro/_next/static/media/mnt.a475f2cb.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};